import {Component, Input, OnInit} from '@angular/core';
import {V3Dictation, V3DictationAnswerHolder, V3ExerciseSessionQuestion} from "../../../../cspa/model/v3/cspa";
import {BlockComparator} from "../../../../utils/text-compare";

@Component({
    selector: 'app-dict-result',
    templateUrl: './dict-result.component.html',
    styleUrls: ['./dict-result.component.scss'],
    standalone: false
})
export class DictResultComponent implements OnInit {
  @Input() questions: V3ExerciseSessionQuestion[] = []

  constructor() { }

  ngOnInit(): void {
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestion) {
    const questionDef = q.questionDef as V3Dictation
    return questionDef.answerDef.answer
  }

  getStudentAnswer(q: V3ExerciseSessionQuestion) {
    const questionDef = q.questionDef as V3Dictation
    const answerHolder = questionDef.answerDef.answerHolder as V3DictationAnswerHolder | null
    if(!answerHolder?.answer) return [null]
    const correctAnswerStream = BlockComparator.tokenize(questionDef.answerDef.answer);
    const userAnswer = BlockComparator.tokenize(answerHolder.answer);
    const result = BlockComparator.compare(correctAnswerStream, userAnswer);
    const blocks = BlockComparator.divideToBlocks(result, userAnswer);
    return BlockComparator.compressBlocks(blocks);
  }
}
